<template>
  <div id="app">
    <TwitchExt></TwitchExt>
    <router-view v-if="isAuthed && releaseState != ''" />
  </div>
</template>

<script>
import { SET_RELEASE_STATE } from "@/store/mutations";

import { mapState } from "vuex";
import TwitchExt from "@/components/TwitchExt.vue";

export default {
  name: "app",
  data() {
    return {
      hasFetchedInitialState: false,
      releaseState: "",
    };
  },
  computed: {
    ...mapState(["isAuthed"]),
    canFetchInitialState() {
      return this.isAuthed;
    },
  },
  watch: {
    canFetchInitialState() {
      if (this.hasFetchedInitialState) {
        return;
      }
      this.hasFetchedInitialState = true;
    },
  },
  created () {
    this.releaseState = this.$route.query.state;
    this.$store.commit(SET_RELEASE_STATE, this.releaseState);
  },
  components: {
    TwitchExt,
  },
};
</script>
